export const MAIL_TYPES: { [key: string]: string } = {
    UnreadableDocument: 'Document Illisible',
    MissingInformation: 'Information(s) Manquante(s)',
    NoncompliantCompany: 'Société Non Conforme',
    NotFoundSupplier: 'Fournisseur Non Trouvé',
    InvalidDocument: 'Document Non Valide',
};
